module.exports = __webpack_public_path__ + "static/img/rice1.ef487ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/rice1.png
// module id = 9G1g
// module chunks = 1